import type { UnifiedContext } from '../context';
import { resolveAnchor } from './utilty';

export const handleTrialLink = (el: HTMLElement, ctx: UnifiedContext) => {
  const { storeTrialLink } = el.dataset;
  if (storeTrialLink === undefined) return;
  const option = ctx.option;
  if (!option) return;

  const link = resolveAnchor(el);
  if (!link) return;

  link.href = option.getTrialLink() || '';
};
